// extracted by mini-css-extract-plugin
module.exports = {"shadow":"FilterList_shadow__2PwqU","filterListContainer":"FilterList_filterListContainer__2UPFW"};